module.exports = __webpack_public_path__ + "static/mission-0e382241b128135ceadfc0e797ee96ef.png";